import React, { useState, useEffect } from 'react'
import {
  SafeAreaView,
  StatusBar,
  Platform,
  ImageBackground,
  View,
  FlatList,
  TouchableOpacity,
  Linking,
} from 'react-native'
import PropTypes from 'prop-types'
import moment from 'moment'
import ContentLoader, { Rect } from 'react-content-loader/native'
import { Colors, Images, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import { VFHeader, Icon } from '@vfgroup-oneplatform/foundation/Components'

import VfText from '../../Components/VfText'
import Countdown from '../../Components/Countdown/Countdown'
import HorizontalLine from '../../Components/HorizontalLine'
import InfoModal from '../../Components/InfoModal'

import images from '../../Themes/Images'

import styles from './VDayOffers.Styles'

function CardPlaceholder({
  theme,
}) {
  const {
    background,
    foreground,
  } = theme

  return (
    <View style={styles.card}>
      <TouchableOpacity style={styles.itemContent} >
        <View style={styles.itemInfo}>

          <ContentLoader
            speed={0.6}
            width={35}
            height={35}
            backgroundColor={background}
            foregroundColor={foreground}
            style={styles.loaderContainer}
          >
            <Rect x="0" y={0} rx="6" ry="6" width={35} height={35} />
          </ContentLoader>

          <View>
            <ContentLoader
              speed={0.6}
              width={150}
              height={10}
              backgroundColor={background}
              foregroundColor={foreground}
              style={styles.loaderContainer}
            >
              <Rect x="0" y={0} rx="6" ry="6" width={150} height={10} />
            </ContentLoader>
            <ContentLoader
              speed={0.6}
              width={200}
              height={10}
              backgroundColor={background}
              foregroundColor={foreground}
              style={styles.loaderContainer}
            >
              <Rect x="0" y={0} rx="6" ry="6" width={200} height={10} />
            </ContentLoader>
          </View>
        </View>
        <ContentLoader
          speed={0.6}
          width={15}
          height={30}
          backgroundColor={background}
          foregroundColor={foreground}
          style={styles.loaderContainer}
        >
          <Rect x="0" y={0} rx="6" ry="6" width={15} height={30} />
        </ContentLoader>
      </TouchableOpacity>
    </View>
  )
}
CardPlaceholder.propTypes = {
  theme: PropTypes.object,
}
function VDayOffers({ onClose, isContentLoading, vdayProducts, getVdayOffers }) {

  const [isVisible, setIsVisible] = useState(false)

  const toggleModal = () => setIsVisible(prev => !prev)

  const theme = useTheme()

  const cLoaderColors = {
    background: theme.colors.shimmerCenterColor,
    foreground: theme.colors.shimmerEdgesColor,
  }



  return (
    // <SafeAreaView style={styles.container}>
    <ImageBackground
      source={images.background_waves_red}
      style={styles.container}
    >
      <VFHeader
        showBack
        onBack={onClose}
        title=" "
        showClose={false}
        headerStyle={styles.headerStyle}
        leftIcon={images.arrowLeftWhite}
      />
      <View style={styles.offersContainer(theme)}>

        <View style={styles.countdownCard(theme)}>
          <Countdown
            to={moment(vdayProducts.validityPeriod)}
            format="YYYYMMDDTHHmmss.SSS Z"
            isContentLoading={isContentLoading}
          />
        </View>

        <View style={styles.offersTitleContainer}>
          <VfText
            i18nKey="vday_explore_offers"
            size="h2"
            color={theme.colors.textColor}
            weight="bold"
          />
          <TouchableOpacity
            onPress={toggleModal}
            style={styles.infoButton}
          >
            <VfText
              i18nKey="vday_more_info"
              size="h5"
              color={Colors.vfRed}
              weight="light"
            />
            <Icon
              name={images.info_red}
              size={30}
              type="image"
              resizeMode="contain"
              style={styles.infoIcon}
            />
          </TouchableOpacity>
        </View>
        <HorizontalLine style={styles.line} />

        <FlatList
          keyExtractor={item => item.id}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={styles.flatlistContainer}
          data={vdayProducts?.items || []}
          renderItem={({ item }) => {
            return (
              <View style={styles.card(theme)}>
                <TouchableOpacity
                  style={styles.itemContent}
                  onPress={() => {
                    Linking.openURL(item.url)
                  }}
                >
                  <View style={styles.itemInfo}>

                    <Icon
                      name={{ uri: item.imageUrl }}
                      size={50}
                      type="image"
                      resizeMode="contain"
                      style={styles.itemImage}
                    />

                    <View style={styles.textContainer}>
                      <VfText
                        i18nKey={item.name}
                        size="body"
                        //color={item.title_color}
                        weight="light"
                        color={theme.colors.textColor}
                      />
                      <VfText
                        i18nKey={item.desc}
                        size="body"
                        weight="bold"
                        color={theme.colors.textColor}
                      />
                    </View>

                  </View>
                  <TouchableOpacity
                    onPress={() => Linking.openURL(item.url)}
                  >
                    <Icon
                      name={Images.ic_chevron_right_red}
                      size={30}
                      type="image"
                      resizeMode="contain"
                    />
                  </TouchableOpacity>
                </TouchableOpacity>
              </View>
            )
          }}
          ListEmptyComponent={<View>
            <CardPlaceholder theme={cLoaderColors} />
            <CardPlaceholder theme={cLoaderColors} />
            <CardPlaceholder theme={cLoaderColors} />
            <CardPlaceholder theme={cLoaderColors} />
            <CardPlaceholder theme={cLoaderColors} />
          </View>}
        />
      </View>

      <InfoModal isVisible={isVisible} closeModal={toggleModal} />
    </ImageBackground>
    // </SafeAreaView>
  )
}

VDayOffers.defaultProps = {}

VDayOffers.propTypes = {
  onClose: PropTypes.func,
  isContentLoading: PropTypes.bool,
  vdayProducts: PropTypes.object,
  getVdayOffers: PropTypes.func,
}

export default VDayOffers
